import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: "L'importazione è quasi pronta!",
      description: "Clicca su Procedi per completare l'importazione",
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Alcuni dati nel file sono mancanti o hanno formato errato',
      description: 'Correggi gli errori e ricarica il file o procedi per ignorare le righe/celle non valide',
    },
    [ValidationStatus.Invalid]: {
      title: 'Il file caricato non può essere elaborato',
      description: 'Correggi gli errori seguenti e riprova',
    },
  },
  sections: {
    heading_validation: {
      title: 'Rilevata discrepanza nei nomi/ordine delle colonne:',
      rules: {
        Exact: 'La colonna #{{column}} deve essere presente e chiamarsi esattamente <strong>{{expected}}</strong>',
      },
    },
    content_validation: {
      title: 'Errori rilevati:',
      labels: {
        row: 'Riga <strong>#{{row}}:</strong>',
        imported_rows_one: '{{count}} riga verrà importata',
        imported_rows_other: '{{count}} righe verranno importate',
        ignored_rows_one: '{{count}} riga verrà ignorata',
        ignored_rows_other: '{{count}} righe verranno ignorate',
      },
      fields: {
        email: 'Email',
        phone_number: 'Numero di telefono',
        first_name: 'Nome',
        last_name: 'Cognome',
        birthday: 'Data di nascita',
      },
      rules: {
        Required: 'Il campo {{field}} è obbligatorio. La riga verrà ignorata',
        Email: 'Il campo {{field}} deve essere un indirizzo email valido. La riga verrà ignorata',
        Phone:
          'Il campo {{field}} deve essere un numero di telefono in formato internazionale. Il campo verrà ignorato',
        Date: 'Il campo {{field}} deve essere una data valida. Il campo verrà ignorato',
      },
    },
  },
  buttons: {
    back_to_upload: 'Torna al caricamento',
    proceed: 'Procedi',
  },
  toasts: {
    error: 'Qualcosa è andato storto, contatta il supporto',
  },
};
